import axios from "axios";
import { baseApi } from "../baseApi";
export const authApi = baseApi.injectEndpoints({
  tagTypes: [],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: `/users/login.json`,
        method: "POST",
        body: body,
      }),
      transformResponse: (response, meta, arg) => {
        return { ...response?.response?.data, msg: response?.response?.msg };
      },
    }),
    changePindCode: builder.mutation({
      query: (body) => ({
        url: `/users/change_pincode.json`,
        method: "POST",
        body: body,
      }),
      transformResponse: (response, meta, arg) => response?.response,
    }),

    getUserDetails: builder.query({
      query: (params) => ({
        url: `/demographics/patient_summary.json`,
        method: "get",
        params,
      }),
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getPatientPermissions: builder.query({
      query: (params) => ({
        url: `/acl/getPatientAclList.json`,
        method: "get",
        params,
      }),
      transformResponse: (response, meta, arg) => response?.response?.data,
     }),
    }),
  
});

// Export hooks for usage in functional components
export const {
  useLoginMutation,
  useGetUserDetailsQuery,
  useChangePindCodeMutation,
} = authApi;


// after discuss with asad bhai
export function centralAuth(data) {
  return axios.post(
    `${process.env.REACT_APP_CENTRAL_AUTH_API_URL}/login.json`,
    data
  );
}

export function forgetpasswordService(data) {
  return axios.post(
    `${process.env.REACT_APP_CENTRAL_AUTH_API_URL}/users/send_forget_password_email.json`,
    data
  );
}
